// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    endHubDiscoveryFail: {
        id: 'install-devices.alerts.end-hub-discovery-fail',
        description: 'Hub is a product',
        defaultMessage: "There was a problem turning off your Hub's discovery mode"
    },
    startHubDiscoveryFail: {
        id: 'install-devices.alerts.start-hub-discovery-fail',
        defaultMessage: "There was a problem starting your Hub's discovery mode"
    },
    warning: {
        id: 'install-devices.alerts.warning',
        defaultMessage: "We're having trouble getting your new devices but we'll keep trying"
    }
});



// WEBPACK FOOTER //
// ./src/core/state/acquire-devices/intl.js